var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLt(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 480,
    width: 640,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    transform: "matrix(.64143 0 0 .96773 0 0)",
    strokeWidth: "1pt"
  }, /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(.93865 0 0 .69686 0 0)",
    rx: 0,
    ry: 0,
    width: 1063,
    height: 708.66,
    fill: "#007308"
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(.93865 0 0 .69686 0 0)",
    rx: 0,
    ry: 0,
    width: 1063,
    y: 475.56,
    height: 236.22,
    fill: "#bf0000"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffb300",
    d: "M0 0h997.77v164.61H0z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLt);
export default __webpack_public_path__ + "static/media/lt.067d1f248e75df6a3fa72ee4ebd978cf.svg";
export { ForwardRef as ReactComponent };